'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _OEMBED_PATH;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _require = require('lodash'),
    findKey = _require.findKey,
    get = _require.get,
    isEmpty = _require.isEmpty,
    startsWith = _require.startsWith;

var _require2 = require('../utils'),
    numberOrZero = _require2.numberOrZero;

var OLD_IMAGE_TYPE = 'IMAGE';
var IMAGE_TYPE = 'wix-draft-plugin-image';
var GALLERY_TYPE = 'wix-draft-plugin-gallery';
var ALL_IMAGE_ENTITY_TYPES = [OLD_IMAGE_TYPE, IMAGE_TYPE, GALLERY_TYPE];

var getCoverFromImage = function getCoverFromImage(entity) {
  var src = get(entity, 'data.src');
  if (src && src.fallback) {
    return {
      file_name: src.file_name || src.fallback,
      width: numberOrZero(src.width),
      height: numberOrZero(src.height)
    };
  } else {
    return src;
  }
};
var getCoverFromGallery = function getCoverFromGallery(entity) {
  var item = get(entity, 'data.items[0]');
  return item ? {
    file_name: item.url,
    width: item.metadata ? item.metadata.width : 0,
    height: item.metadata ? item.metadata.height : 0
  } : {};
};
var getPostContentEntityMap = function getPostContentEntityMap(post) {
  return get(post, 'content.entityMap', {});
};

var getPostImageCover = function getPostImageCover(post) {
  var entities = getPostContentEntityMap(post);
  var key = findKey(entities, function (entity) {
    return ALL_IMAGE_ENTITY_TYPES.indexOf(entity.type) > -1;
  });
  var entity = entities[key];

  return entity ? getCoverFromImage(entity) || getCoverFromGallery(entity) : undefined;
};

var OLD_VIDEO_EMBED_TYPE = 'VIDEO-EMBED';
var VIDEO_EMBED_TYPE = 'wix-draft-plugin-video';
var ALL_VIDEO_EMBED_ENTITY_TYPES = [OLD_VIDEO_EMBED_TYPE, VIDEO_EMBED_TYPE];

var OEMBED_PATH = (_OEMBED_PATH = {}, _OEMBED_PATH[OLD_VIDEO_EMBED_TYPE] = 'data.oembed', _OEMBED_PATH[VIDEO_EMBED_TYPE] = 'data.metadata.oembed', _OEMBED_PATH);

var getCoverFromOembed = function getCoverFromOembed(entity) {
  if (!get(entity, OEMBED_PATH[entity.type] + '.thumbnail_url')) {
    return undefined;
  }
  var path = get(entity, OEMBED_PATH[entity.type]);
  if (startsWith(path.thumbnail_url, '//')) {
    return _extends({}, path, { thumbnail_url: 'https:' + path.thumbnail_url });
  }
  return path;
};

var getCoverFromVideo = function getCoverFromVideo(entity, _ref) {
  var resizeThumbnail = _ref.resizeThumbnail,
      getVideoUrl = _ref.getVideoUrl;

  if (!(resizeThumbnail && getVideoUrl)) {
    return undefined;
  }

  var video = get(entity, 'data.src');
  var thumbnail = get(entity, 'data.src.thumbnail');

  if (!thumbnail) {
    return undefined;
  }

  var resized = resizeThumbnail(thumbnail.pathname, thumbnail.width, thumbnail.height);

  return {
    thumbnail_url: resized.url,
    thumbnail_height: resized.height,
    thumbnail_width: resized.width,
    video_url: getVideoUrl(video.pathname)
  };
};

var getPostVideoEmbedCover = function getPostVideoEmbedCover(post) {
  var helpers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var entities = getPostContentEntityMap(post);
  var key = findKey(entities, function (entity) {
    return ALL_VIDEO_EMBED_ENTITY_TYPES.includes(entity.type) && (get(entity, OEMBED_PATH[entity.type] + '.thumbnail_url') || get(entity, 'data.src.thumbnail'));
  });
  var entity = entities[key];

  return entity ? getCoverFromOembed(entity) || getCoverFromVideo(entity, helpers) : undefined;
};

var getCustomCoverImage = function getCustomCoverImage(post) {
  var _ref2 = get(post, 'coverImage', {}) || {},
      _ref2$isEnabled = _ref2.isEnabled,
      isEnabled = _ref2$isEnabled === undefined ? true : _ref2$isEnabled,
      _ref2$isCustom = _ref2.isCustom,
      isCustom = _ref2$isCustom === undefined ? true : _ref2$isCustom,
      src = _ref2.src;

  return isEmpty(src) ? { isEnabled: isEnabled, isCustom: false } : {
    isEnabled: isEnabled,
    imageMetadata: src,
    isCustom: isCustom
  };
};

var getResolvedCoverImage = function getResolvedCoverImage(post) {
  var _ref3 = post.coverImage || {},
      isResolved = _ref3.isResolved,
      props = _objectWithoutProperties(_ref3, ['isResolved']);

  return isResolved === true ? props : undefined;
};

var getPostCover = function getPostCover(post) {
  var helpers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var resolvedCoverImage = getResolvedCoverImage(post);
  if (resolvedCoverImage) {
    return resolvedCoverImage;
  }

  // eslint-disable-next-line prefer-const

  var _getCustomCoverImage = getCustomCoverImage(post),
      imageMetadata = _getCustomCoverImage.imageMetadata,
      videoMetadata = _getCustomCoverImage.videoMetadata,
      isCustom = _getCustomCoverImage.isCustom,
      isEnabled = _getCustomCoverImage.isEnabled;

  if (!imageMetadata) {
    imageMetadata = getPostImageCover(post);
  }

  if (!imageMetadata) {
    videoMetadata = getPostVideoEmbedCover(post, helpers);
  }

  return {
    shouldRender: Boolean(imageMetadata || videoMetadata) && isEnabled,
    imageMetadata: imageMetadata,
    videoMetadata: videoMetadata,
    src: imageMetadata || get(videoMetadata, 'thumbnail_url'),
    isEnabled: isEnabled,
    isCustom: isCustom
  };
};

module.exports = {
  getPostImageCover: getPostImageCover,
  getPostVideoEmbedCover: getPostVideoEmbedCover,
  getCustomCoverImage: getCustomCoverImage,
  getPostCover: getPostCover,
  getResolvedCoverImage: getResolvedCoverImage
};